var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("channel", {
    attrs: {
      type: "pinterest",
      text: _vm.shareText,
      link: _vm.link,
      poster: _vm.episodePoster,
      color: _vm.color,
      background: _vm.background,
      filled: _vm.hover
    },
    nativeOn: {
      mouseover: function($event) {
        _vm.hover = true
      },
      mouseleave: function($event) {
        _vm.hover = false
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }